
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/agents/openbook",
      function () {
        return require("private-next-pages/agents/openbook.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/agents/openbook"])
      });
    }
  